<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('IMC')"
          :class="['nav-link link-nav-resident', step == 'IMC' && 'active']"
          id="nav-imc"
          data-toggle="tab"
          href="#imc"
          role="tab"
          aria-controls="imc"
          aria-selected="true"
          >IMC <small>(Peso/Altura)</small></a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'IMC'"
        :class="['tab-pane fade', step == 'IMC' && 'show active']"
        id="imc"
        role="tabpanel"
        aria-labelledby="nav-imc"
      >
        <IMC />
      </div>
    </div>
  </div>
</template>

<script>
import IMC from "./IMC/IMC";

import routes from "../../routes";

export default {
  name: "MenuIMC",

  components: {
    IMC,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "IMC",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "IMC") {
        newNav = "imc";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "imc") {
          this.step = "IMC";
        }
      }
    },
  },
};
</script>

